import styled from 'styled-components'
import { rem } from 'polished'
import { SearchButton } from '../ListingDrawerSearchControls.styles'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import ExperiencesSearchDateSelectDropdown from 'components/Search/Experiences/ExperiencesSearchDateSelectDropdown'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { SearchMenuStates } from 'components/Search/type'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ListingDrawerMobileExperienceDateFields from '../ListingDrawerMobileExperienceDateFields'
import useExperienceListingSearchControls, { type ExperienceListingSearchControlsParams } from '../../hooks/useExperienceListingSearchControls'

interface Props extends ExperienceListingSearchControlsParams {
  searchCalendarFocusDate?: Date
}

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  position: relative;
  width: 100%;
`
const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};
  align-items: stretch;
`
const DateInputContainer = styled.div`
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  ${mediaQueryUp.tablet} {
    flex: 1 1 ${rem(220)};
    min-width: ${rem(180)};
    width: auto;
  }
`
const StyledSearchFormField = styled(SearchFormField)`
  width: 100%;
`

function ExperienceListingSearchControls(props: Props) {
  const { whenLabel, searchCalendarFocusDate } = props
  const {
    searchState, searchDispatch, controlsContainerRef, experienceDateTriggerRef,
    isCompactDatePicker, isExperienceDatePanelOpen, openDates, cancelDates, applyDates, handleSubmit,
    anytimeLabel, searchButtonLabel, experienceWhenLabel,
    experienceDateFieldValue, experienceTripDateRangeMoments,
  } = useExperienceListingSearchControls(props)

  return (
    <ControlsContainer ref={controlsContainerRef}>
      <GlobalSearchContextProvider state={searchState} dispatch={searchDispatch}>
        <Form onSubmit={handleSubmit}>
          <DateInputContainer>
            {isCompactDatePicker ? (
              <ListingDrawerMobileExperienceDateFields isOpen={isExperienceDatePanelOpen} onOpen={openDates} onClose={cancelDates} onConfirm={applyDates} whenLabel={experienceWhenLabel} anytimePlaceholder={anytimeLabel} tripDateRange={experienceTripDateRangeMoments} focusMonth={searchCalendarFocusDate} />
            ) : (
              <>
                <StyledSearchFormField ref={experienceDateTriggerRef} label={whenLabel} placeholder={anytimeLabel} value={experienceDateFieldValue} onClick={openDates} />
                <ExperiencesSearchDateSelectDropdown anchorRef={controlsContainerRef} triggerRef={experienceDateTriggerRef} open={searchState.activeMenu === SearchMenuStates.Dates} onApply={applyDates} onDecline={cancelDates} tripDateRange={experienceTripDateRangeMoments} showNextBooking={false} focusMonth={searchCalendarFocusDate} />
              </>
            )}
          </DateInputContainer>
          <SearchButton className={isCompactDatePicker ? 'compact' : undefined} kind="primary" size="large" type="submit" fit="auto">{searchButtonLabel}</SearchButton>
        </Form>
      </GlobalSearchContextProvider>
    </ControlsContainer>
  )
}

export default ExperienceListingSearchControls
